import { render, staticRenderFns } from "./LangChoose.vue?vue&type=template&id=f7b8ffc8&scoped=true&"
import script from "./LangChoose.vue?vue&type=script&lang=js&"
export * from "./LangChoose.vue?vue&type=script&lang=js&"
import style0 from "./LangChoose.vue?vue&type=style&index=0&id=f7b8ffc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b8ffc8",
  null
  
)

export default component.exports